export const Config = window.Configs || {};

export const Routes = {
	//Dashboard
	Dashboard: "/MyDashboard",
	MyDashboard: "/MyDashboard",
	SpDashboard: "/SpDashboard",
	CMDashboard: "/CMDashboard",
	//Leave Management
	CreateLeave: "/CreateLeave",
	LeaveDetail: "/LeaveDetail",
	ManageLeavesView: "/ManageLeavesView",
	//OffsiteWorkHours
	OffsiteWorkHours: "/OffsiteWorkHours",
	OffsiteWorkHoursRequest: "/OffsiteWorkHoursRequest",
	//Item Requisition
	ItemRequisition: "/ItemRequisition",
	ReviewItemRequsition: "/ReviewItemRequsition",
	ItemRequisitionCategories: "/ItemRequisitionCategories",
	ItemRequisitionClasses: "/ItemRequisitionClasses",
	ReviewItemRequisitionDetail: "/ReviewItemRequisitionDetail",
	CreateItemRequisition: "/CreateItemRequisition",
	ItemRequisitionVendors: "/ItemRequisitionVendors",
	ItemRequisitionDetail: "/ItemRequisitionDetail",
	SSNItemRequisitionDetail: "/SSNItemRequisitionDetail",
	//Vendor
	CreateNewVendor: "/CreateNewVendor",
	VendorCategories: "/VendorCategories",
	VendorContact: "/VendorContact",
	//Project
	ProjectListing: "/ProjectListing",
	UpdateProject: "/UpdateProject",
	ProjectHistory: "/ProjectHistory",
	//Ticket
	MyTickets: "/MyTickets",
	TicketDetails: "/TicketDetails",
	TicketHistory: "/TicketHistory",
	EditTicket: "/EditTicketByResource",
	DeptTicketApproval: "/DeptTicketApproval",
	DeptTicketListing: "/DepartmentTicketListing",
	//Supervisor
	SpTimesheetStatus: "/SpTimesheet/",
	SpReviewLeave: "/SpReviewLeave",
	SpReviewedLeave: "/SpReviewedLeave",
	SpTimeSheetStatus: "/SpTimeSheetStatus",
	ReviewLeaveApplication: "/SpReviewLeave",
	spOffsiteWorkHours: "/spOffsiteWorkHours",
	//Bug
	Bug: "/Bug",
	ReportedBugs: "/ReportedBugs",
	FeedbackStatusDetails: "/feedbackStatusDetails",
	//Profile
	MyProfile: "/MyProfile",
	EditProfile: "/EditProfile",
	//CM
	CMAssignedTickets: "/CMAssignedTickets",
	CMTicketApproval: "/CMTicketApproval",
	ViewEmployees: "/ViewEmployees",
	CMTicketListing: "/CountryManagerTicketListing",
	//Admin
	AddNewHoliday: "/AddNewHoliday",
	AdminCalendarHolidays: "/AdminCalendarHolidays",
	AdminViewLeaves: "/adminRole/ViewLeaves",
	AdminEmployeeWorkStatus: "/adminRole/EmployeeWorkStatus",
	AdminCompensationLog: "/adminRole/CompensationLog",
	AdminCompensationLogDetail: "/adminRole/CompensationLogDetail/",
	AdminAddEmployeeWorkStatusForm: "/adminRole/AddEmployeeWorkStatusForm",
	//Misc
	MyTimeSheetsStatus: "/WeeklyView",
	ResourceLeavesInfo: "/ResourceLeavesInfo/",
	MyTimeSheetStatus: "/MyTimeSheetStatus",
	TimesheetPerformanceReport: "/TimesheetPerformanceReport",
};
